import React from 'react';

export default function PaymentPending() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>Pago pendiente de confirmación</h2>
      <p>Tu pago está siendo procesado. Te notificaremos cuando se confirme.</p>
      <a href="/onboarding">Volver al inicio</a>
    </div>
  );
} 